import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '@/App';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SubscriptionSuccess = () => {
  const { user, refreshUser } = useContext(AuthContext);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('checking'); // checking, success, error
  const [attempts, setAttempts] = useState(0);
  const maxAttempts = 5;

  useEffect(() => {
    const sessionId = searchParams.get('session_id');
    if (sessionId) {
      pollPaymentStatus(sessionId);
    } else {
      setStatus('error');
    }
  }, [searchParams]);

  const pollPaymentStatus = async (sessionId, attempt = 0) => {
    if (attempt >= maxAttempts) {
      setStatus('error');
      toast.error('Vérification du paiement expirée. Veuillez vérifier votre email.');
      return;
    }

    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API}/checkout/status/${sessionId}`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        withCredentials: true
      });

      if (response.data.payment_status === 'paid') {
        setStatus('success');
        toast.success('Paiement confirmé! Vous êtes maintenant Premium!');
        await refreshUser(); // Refresh user data
        setTimeout(() => navigate('/'), 2000);
        return;
      } else if (response.data.status === 'expired') {
        setStatus('error');
        toast.error('Session de paiement expirée');
        return;
      }

      // Continue polling
      setAttempts(attempt + 1);
      setTimeout(() => pollPaymentStatus(sessionId, attempt + 1), 2000);
    } catch (error) {
      console.error('Error checking payment status:', error);
      setStatus('error');
      toast.error('Erreur lors de la vérification du paiement');
    }
  };

  return (
    <div>
      {/* Navbar */}
      <nav className="navbar">
        <div className="navbar-content">
          <a href="/" className="navbar-logo" data-testid="navbar-logo">LE REGISTRE</a>
        </div>
      </nav>

      {/* Status Content */}
      <div className="subscription-container">
        <div className="subscription-card" data-testid="status-card">
          {status === 'checking' && (
            <>
              <div className="loading-spinner" style={{ margin: '2rem auto' }}></div>
              <h2 data-testid="status-checking">Vérification du paiement…</h2>
              <p className="subscription-note">
                Veuillez patienter pendant la confirmation de votre accès.
              </p>
            </>
          )}
          {status === 'success' && (
            <>
              <div style={{ fontSize: '3rem', marginBottom: '1rem', color: 'var(--accent)' }}>✓</div>
              <h2 data-testid="status-success">Accès étendu confirmé</h2>
              <p className="subscription-note">
                Les archives complètes du Registre vous sont désormais ouvertes. Redirection en cours…
              </p>
            </>
          )}
          {status === 'error' && (
            <>
              <div style={{ fontSize: '3rem', marginBottom: '1rem', color: 'var(--danger)' }}>✗</div>
              <h2 data-testid="status-error">Une erreur s'est produite</h2>
              <p className="subscription-note">
                Veuillez réessayer ou contacter le support si le problème persiste.
              </p>
              <button onClick={() => navigate('/')} className="btn btn-primary" style={{ marginTop: '2rem' }} data-testid="return-home-button">
                Retour à l'accueil
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default SubscriptionSuccess;
